
import {Component, Vue, Watch} from "vue-property-decorator";
import UserGroupEdit from "@/components/users/UserGroupEdit.vue";
import { ROWS_PER_PAGE } from "@/utils/constants";
import { Getter } from "vuex-class";
@Component({
    components: {
        UserGroupEdit,
    },
})

export default class UserGroupPage extends Vue {
    @Getter private envCompanyId: number|null;
    @Getter private isMobile: boolean;

    get isLoaded(): boolean {
        return !!this.group;
    }
    private group: any = null;
    private userGroupId = null;
    private loadingUsers: boolean = false;
    private usersPagination: any = {
        sortDesc: [false],
        sortBy: [""],
        page: 1,
        itemsPerPage: 10,
    };
    private usersSearch: string = "";
    private usersCount: number = 0;
    private displayUsers: boolean = true;
    private users: any = [];
    private usersGroupHeaders: object[] = [];
    private displayEditUserGroupDialog: boolean = false;
    private userGroup: any = null;
    private ROWS_PER_PAGE = ROWS_PER_PAGE;

    @Watch("usersPagination")
    public handlerUsersPagination(val, oldVal) {
        if (oldVal.page !== val.page || val.itemsPerPage !== oldVal.itemsPerPage) {
            this.getUsersInGroup();
        }
    }

    private mounted(): void {
        this.userGroupId = Number(this.$route.params.id);
        this.reset();
    }

  private back() {
    this.clearData();
    return this.$router.push({ name: "contacts", params: { tab: "groups" } });
  }

  private clearData() {
    this.usersGroupHeaders = [
      { value: "number", sortable: false },
      { value: "firstName", text: this.$t("user.username"), sortable: true },
      { value: "createdAt", text: this.$t("user.createdAtSentence"), sortable: true },
    ];
    this.displayEditUserGroupDialog = false;
    this.userGroup = null;
  }

  private reset() {
    this.getUserGroupById();
    this.getUsersInGroup();
    this.clearData();
  }

    private getUserGroupById(): Promise<void> {
        return this.$store.dispatch("userGroups/getById", {id: this.userGroupId})
            .then((res) => {
                this.group = res;
            }).catch((err) => {
                this.$store.commit("alerts/displayError", {
                    msg: err,
                });
            });
    }

    private getUsersInGroup(): Promise<void> {
        this.loadingUsers = true;
        return this.$store.dispatch("userGroups/getUsersInGroup", {
            id: this.userGroupId,
            params: {
              ...this.usersPagination,
              search: this.usersSearch,
            },
        }).then((res) => {
            this.users = res?.users || [];
            this.usersCount = res?.count;
        }).catch((err) => {
                this.$store.commit("alerts/displayError", {
                    msg: err,
                });
        }).finally(() => {
            this.loadingUsers = false;
        });
    }

    private userRowClick(row) {
        this.$router.push({name : "user", params: {id: row.id, groupId : this.userGroupId,
            groupName : this.group.name}});
    }

    private openEditUserGroup() {
        this.userGroup = {Users: this.users.map(({UsersGroup, ...user}) => user), ... this.group};

        this.displayEditUserGroupDialog = true;
    }

    private keyDownEvent(e: KeyboardEvent) {
      if (e.key === "Enter") {
        this.getUsersInGroup();
      }
    }

}
